import { useState, useCallback } from "react";

const Gallery = ({data}) => {
  const [index, setIndex] = useState(0);

  // visible slides count based on screen size
  const getVisibleSlides = () => {
    if (window.innerWidth >= 1024) return 3;
    if (window.innerWidth >= 640) return 2;
    return 1;
  };

  const visible = getVisibleSlides();
  const maxIndex = data.gallary.length - visible;

  const nextSlide = useCallback(() => {
    setIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  }, [maxIndex]);

  const prevSlide = useCallback(() => {
    setIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
  }, [maxIndex]);

  return (
    <section id="gallary" className="py-10 bg-white overflow-hidden">
      <h2 className="text-center text-3xl font-semibold text-[#090C6A]">
        Siddha Sky - Project Gallery
      </h2>
      <div className="w-20 h-[2px] bg-[#090C6A] mx-auto my-3"></div>

      <div className="relative max-w-6xl mx-auto mt-10 overflow-hidden">
        <div
          className="flex transition-transform duration-700 ease-in-out"
          style={{ transform: `translateX(-${index * (100 / visible)}%)` }}
        >
          {data.gallary.map((img, i) => (
            <div
              key={i}
              className="w-full sm:w-1/2 lg:w-1/3 px-2 shrink-0"
            >
              <div className="relative overflow-hidden rounded-lg shadow-lg">
                <img
                  src={img}
                  alt="Premium residences in Wadala"
                  className="w-full h-[220px] object-cover"
                />
              </div>
            </div>
          ))}
        </div>

        {/* Controls */}
        <div className="flex justify-center gap-6 mt-6 mb-2">
          <button
            onClick={prevSlide}
            className="w-10 h-10 bg-white shadow-md rounded-full flex items-center justify-center hover:scale-110 transition"
          >
            ←
          </button>
          <button
            onClick={nextSlide}
            className="w-10 h-10 bg-white shadow-md rounded-full flex items-center justify-center hover:scale-110 transition"
          >
            →
          </button>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
